import { createSlice } from '@reduxjs/toolkit';

const formSlice = createSlice({
    name: 'form',
    initialState: {
        pendingForms: [],
    },
    reducers: {
        addPendingForm(state, action) {
            state.pendingForms.push(action.payload);
        },
        clearPendingForms(state) {
            state.pendingForms = [];
        },
    },
});

export const { addPendingForm, clearPendingForms } = formSlice.actions;
export default formSlice.reducer;